import { useNavigate, useSearchParams } from "react-router";

export function useReturnTo() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const returnTo = searchParams.get("returnTo");

  const goBack = () => {
    if (returnTo) {
      window.location.href = returnTo;
    } else {
      navigate(-1);
    }
  };

  // Appends ?returnTo=<current returnTo> to a path so the chain is preserved
  const withReturnTo = (path: string) =>
    returnTo ? `${path}?returnTo=${encodeURIComponent(returnTo)}` : path;

  return { goBack, withReturnTo };
}
